import { Stack } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ThirdPartyMemberDashboard from "../ThirdPartyMemberDashboard";
import PayGMemberDashboard from "../PayGMemberDashboard";
import B2BMemberDashboard from "../B2BMemberDashboard";
import { trackPageViewV2 } from "@/services/analytics-adapter";
import useGetMemberProfile from "@/features/Dashboard/hooks/useGetMemberProfile";
import { useGlobalStore } from "@/store";
import { pageWithBottomNavigationStyling } from "@/theme";
import BottomNavigation from "@/features/Common/components/BottomNavigation";
import useGetProductType from "@/features/Common/hooks/useGetProductType";
import {
  FeatureToggleIdentifier,
  isFeatureEnabled,
} from "@/services/feature-toggle-adapter";
import PayGMemberDashboardV2 from "../PayGMemberDashboardV2";
import B2BMemberDashboardV2 from "../B2BMemberDashboardV2";

export default function Dashboard() {
  const navigate = useNavigate();
  const { state, dispatch } = useGlobalStore();

  const isThirdPartyMember = state.isThirdPartyMember;
  const { memberProfile, memberProfileFetchError, isMemberProfileLoading } =
    useGetMemberProfile();

  const { isPAYGProduct } = useGetProductType();
  const isTrendedVitalsEnabled = isFeatureEnabled(
    FeatureToggleIdentifier.ENABLE_TRENDED_VITALS
  );

  useEffect(() => {
    const controller = new AbortController();

    if (!state.hasMemberRequiredActionsBeenCompleted) {
      navigate("/member-required-actions");
    } else if (state.redirectLink) {
      navigate(state.redirectLink);
      dispatch({
        type: "CLEAR_REDIRECT_LINK",
      });
    } else {
      trackPageViewV2({
        pageName: "Home:Dashboard",
        pageSubSection1: "Home",
        pageSubSection2: "Home:Dashboard",
        pageCategory: "Home",
      });
    }

    return () => {
      controller.abort();
    };
  }, [
    dispatch,
    memberProfile,
    navigate,
    state.hasMemberRequiredActionsBeenCompleted,
    state.redirectLink,
  ]);

  return (
    <>
      {state.hasMemberRequiredActionsBeenCompleted ? (
        <Stack
          sx={{
            ...pageWithBottomNavigationStyling,
            position: "relative",
          }}
        >
          {isThirdPartyMember ? (
            <ThirdPartyMemberDashboard
              memberProfile={memberProfile}
              isMemberProfileLoading={isMemberProfileLoading}
              memberProfileFetchError={memberProfileFetchError}
            />
          ) : (
            <>
              {isPAYGProduct ? (
                isTrendedVitalsEnabled ? (
                  <PayGMemberDashboardV2
                    memberProfile={memberProfile}
                    isMemberProfileLoading={isMemberProfileLoading}
                    memberProfileFetchError={memberProfileFetchError}
                  />
                ) : (
                  <PayGMemberDashboard
                    memberProfile={memberProfile}
                    isMemberProfileLoading={isMemberProfileLoading}
                    memberProfileFetchError={memberProfileFetchError}
                  />
                )
              ) : isTrendedVitalsEnabled ? (
                <B2BMemberDashboardV2
                  memberProfile={memberProfile}
                  isMemberProfileLoading={isMemberProfileLoading}
                  memberProfileFetchError={memberProfileFetchError}
                />
              ) : (
                <B2BMemberDashboard
                  memberProfile={memberProfile}
                  isMemberProfileLoading={isMemberProfileLoading}
                  memberProfileFetchError={memberProfileFetchError}
                />
              )}
            </>
          )}
          <BottomNavigation />
        </Stack>
      ) : null}
    </>
  );
}
